export const MOBILE_BREAKPOINT = "(max-width: 480px)";
